import {
  Button,
  DragAndDropUpload,
  Icons,
  Loading,
  Modal
} from "@gpstrackit/gtc-react-controls";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "Components/Notifications";
import { clearRedux } from "Redux/actions";
import { Divider, TextField } from "@mui/material";
import { createUUID } from "../../../../../../../core/data/Helpers";
import { reset, uploadFiles } from '../../redux/slice';
import './styles.scss'

const EXTENSIONS = [".kmz", ".kml"];
const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-]+$/;

export const UploadLayer = ({ isOpenModal, setIsModalOpen, validateExistName }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const [filesUploaded, setFilesUploaded] = useState([]);
  const [maxFileError, setMaxFileError] = useState(false);
  const [existNameError, setExistNameError] = useState(false);
  const { responseCreateFiles, loadingCreateFile } = useSelector(state => state.filesRedux);

  useEffect(() => {
    if (responseCreateFiles && !loadingCreateFile) {
      NotificationManager.success(
        messages["realtimemaps_layer_map_layer_uploadFile"],
        messages["success"],
        3000,
        null,
        null,
        "success"
      );
      setIsModalOpen(false);
      clearFields();
      dispatch(reset({
        responseCreateFiles: null, loadingCreateFile: false
      }))
    }
  }, [loadingCreateFile, responseCreateFiles]);

  const effectMaxFileError = () => {
    setMaxFileError(true);
    setTimeout(() => setMaxFileError(false), 3000);
  };

  const clearFields = () => {
    setFilesUploaded([]);
    setMaxFileError(false)
    setExistNameError(false)
  };

  const onChangeFile = (files = []) => {
    const buildFile = [];
    files?.map((item) => {
      buildFile.push({
        id: createUUID(),
        fileKey: item?.file,
        originalName: item?.file?.name?.split(".")[0],
      });
    });
    setFilesUploaded([...filesUploaded, ...buildFile]);
  };

  const deleteFile = (file = {}) => {
    const filterFile = filesUploaded?.filter((item) => item?.id != file?.id);
    setFilesUploaded(filterFile);
  };

  const validateNames = () => {
    let flag = true;
    const counter = {}
    for (const file of filesUploaded) {
      if (counter[file?.originalName]) {
        flag = false;
      } else {
        counter[file?.originalName] = 1;
      }

      if(file?.originalName?.length === 0){
        flag = false
      }
    }
    return flag;
  };

  const saveFile = async () => {
    if(!validateNames() || !validateExistName(filesUploaded)) return setExistNameError(true)
    setExistNameError(false)
    dispatch(
      uploadFiles({
        files: filesUploaded,
        entityName: "KMZ",
      })
    );
  };

  return (
    <Modal
      open={isOpenModal}
      style={{ height: "400px", top: "40%", left: "40%" }}
      handleClose={() => {
        clearFields();
        setIsModalOpen(!isOpenModal);
      }}
      title={`${messages["realtimemaps_layer_map_layer_kmz"]}`}
      position="center"
      size="large"
      closeButton={() => {
        clearFields();
        setIsModalOpen(!isOpenModal);
      }}
      footer={
        <div className="btns_modal_layerKmz">
          {existNameError && <p style={{margin: "0px", marginRight: '10px', color: 'red', width: '80%'}}>{messages['realtimemaps_layer_map_layer_files_uploaded_exist_name']}</p>}
          <Button
            onClick={() => {
              clearFields();
              setIsModalOpen(!isOpenModal);
            }}
            style={{ marginRight: 8 }}
            variant="secondary"
          >
            close
          </Button>
          <Button
            onClick={() => saveFile()}
            isDisabled={filesUploaded?.length === 0 || loadingCreateFile}
            variant="primary"
          >
            save
          </Button>
        </div>
      }
    >
      {!loadingCreateFile ? (
        <div style={{ padding: "20px", display: "flex", width: "95%" }}>
          <div style={{ width: "45%", marginRight: "15px" }}>
            {filesUploaded?.length >= 20 && (
              <div className="disabled_draganddrop_layerKmz" />
            )}
            <DragAndDropUpload
              onAdd={(files) => {
                const currentFiles = filesUploaded?.length;
                const newFiles = files?.length;
                if (currentFiles + newFiles > 20) return effectMaxFileError(true);
                onChangeFile(files);
              }}
              filesLimit={50}
              filesUploaded={filesUploaded}
              maxFileSize={30000000}
              showAlerts={false}
              acceptedFiles={EXTENSIONS}
              showPreviews={false}
              showFileNamesInPreview={false}
              showPreviewsInDropzone={false}
            />
          </div>
          <Divider
            orientation="vertical"
            flexItem
            style={{ marginRight: "15px" }}
          />
          <div
            style={{
              marginRight: "10px",
              width: "45%",
              height: "250px",
              overflowY: "auto",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ margin: "0px" }}>
                {messages["realtimemaps_layer_map_layer_files_uploaded"]}{" "}
                {filesUploaded?.length}
              </p>
              <p
                className={maxFileError ? "error_efect_layerKmz" : ""}
                style={{ margin: "0px", color: "red" }}
              >
                {
                  messages[
                    "realtimemaps_layer_map_layer_files_uploaded_max_20_files"
                  ]
                }
              </p>
            </div>
            {filesUploaded?.length === 0 ? (
              <div className="no_files_layerKmz">
                <p>
                  {
                    messages[
                      "realtimemaps_layer_map_layer_files_uploaded_no_files"
                    ]
                  }
                </p>
              </div>
            ) : (
              <div style={{ marginTop: "5px" }}>
                {filesUploaded?.map((file) => {
                  return (
                    <div
                      key={file?.id}
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      <Icons size="small" name="layers" color="#212121" />
                      <TextField
                        style={{ width: "350px", marginLeft: "10px" }}
                        defaultValue={file?.originalName}
                        variant="standard"
                        onKeyDown={(event) => {
                          if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const text = e.target.value;
                          const updateFileName = filesUploaded?.map((item) => {
                            if (item?.id === file?.id) {
                              return {
                                ...item,
                                originalName: text,
                              };
                            } else {
                              return { ...item };
                            }
                          });
                          setFilesUploaded(updateFileName)
                        }}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                      />
                      <Icons
                        size="small"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        name="delete"
                        color="red"
                        onClick={() => deleteFile(file)}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading />
        </div>
      )}
    </Modal>
  );
};
